import { graphClient } from '../../graph-client'
import { GET_LIVES_GUESTS_BY_LIVE_ID, UPDATE_LIVE_DETAIL_GUEST } from './gql'
import type { Get, Update } from './types'

class LiveGuestService {
  async get({ liveId }: Get.Input) {
    const request = await graphClient.request<Get.Output>(
      GET_LIVES_GUESTS_BY_LIVE_ID,
      {
        liveId: Number(liveId),
      },
    )

    return request?.getLiveGuestsByLiveId
  }

  async update(params: Update.Input) {
    const request = await graphClient.request<Update.Output>(
      UPDATE_LIVE_DETAIL_GUEST,
      params,
    )

    return request?.updateLiveDetailGuest
  }
}

export const liveGuestService = new LiveGuestService()
